// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file tagn/v1/auth.proto (package tagn.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { User } from "./common_pb";
import { file_tagn_v1_common } from "./common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file tagn/v1/auth.proto.
 */
export const file_tagn_v1_auth: GenFile = /*@__PURE__*/
  fileDesc("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", [file_tagn_v1_common]);

/**
 * TokenPair is returned on successful authentication.
 *
 * @generated from message tagn.v1.TokenPair
 */
export type TokenPair = Message<"tagn.v1.TokenPair"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: int64 access_expires_at_ms = 2;
   */
  accessExpiresAtMs: bigint;

  /**
   * @generated from field: string refresh_token = 3;
   */
  refreshToken: string;

  /**
   * @generated from field: int64 refresh_expires_at_ms = 4;
   */
  refreshExpiresAtMs: bigint;
};

/**
 * Describes the message tagn.v1.TokenPair.
 * Use `create(TokenPairSchema)` to create a new message.
 */
export const TokenPairSchema: GenMessage<TokenPair> = /*@__PURE__*/
  messageDesc(file_tagn_v1_auth, 0);

/**
 * Invitation to register an account.
 *
 * @generated from message tagn.v1.Invitation
 */
export type Invitation = Message<"tagn.v1.Invitation"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: int64 expires_at_ms = 3;
   */
  expiresAtMs: bigint;

  /**
   * @generated from field: bool accepted = 4;
   */
  accepted: boolean;

  /**
   * @generated from field: int64 created_at_ms = 5;
   */
  createdAtMs: bigint;
};

/**
 * Describes the message tagn.v1.Invitation.
 * Use `create(InvitationSchema)` to create a new message.
 */
export const InvitationSchema: GenMessage<Invitation> = /*@__PURE__*/
  messageDesc(file_tagn_v1_auth, 1);

/**
 * GetInvitationRequest is the request message of GetInvitation.
 *
 * @generated from message tagn.v1.GetInvitationRequest
 */
export type GetInvitationRequest = Message<"tagn.v1.GetInvitationRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message tagn.v1.GetInvitationRequest.
 * Use `create(GetInvitationRequestSchema)` to create a new message.
 */
export const GetInvitationRequestSchema: GenMessage<GetInvitationRequest> = /*@__PURE__*/
  messageDesc(file_tagn_v1_auth, 2);

/**
 * GetInvitationResponse is the response message of GetInvitation.
 *
 * @generated from message tagn.v1.GetInvitationResponse
 */
export type GetInvitationResponse = Message<"tagn.v1.GetInvitationResponse"> & {
  /**
   * @generated from field: tagn.v1.Invitation invitation = 1;
   */
  invitation?: Invitation | undefined;
};

/**
 * Describes the message tagn.v1.GetInvitationResponse.
 * Use `create(GetInvitationResponseSchema)` to create a new message.
 */
export const GetInvitationResponseSchema: GenMessage<GetInvitationResponse> = /*@__PURE__*/
  messageDesc(file_tagn_v1_auth, 3);

/**
 * RegisterRequest is the request message of Register.
 *
 * @generated from message tagn.v1.RegisterRequest
 */
export type RegisterRequest = Message<"tagn.v1.RegisterRequest"> & {
  /**
   * @generated from field: string invitation_token = 1;
   */
  invitationToken: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: string password = 3;
   */
  password: string;
};

/**
 * Describes the message tagn.v1.RegisterRequest.
 * Use `create(RegisterRequestSchema)` to create a new message.
 */
export const RegisterRequestSchema: GenMessage<RegisterRequest> = /*@__PURE__*/
  messageDesc(file_tagn_v1_auth, 4);

/**
 * RegisterResponse is the response message of Register.
 *
 * @generated from message tagn.v1.RegisterResponse
 */
export type RegisterResponse = Message<"tagn.v1.RegisterResponse"> & {
  /**
   * @generated from field: tagn.v1.User user = 1;
   */
  user?: User | undefined;

  /**
   * @generated from field: tagn.v1.TokenPair tokens = 2;
   */
  tokens?: TokenPair | undefined;
};

/**
 * Describes the message tagn.v1.RegisterResponse.
 * Use `create(RegisterResponseSchema)` to create a new message.
 */
export const RegisterResponseSchema: GenMessage<RegisterResponse> = /*@__PURE__*/
  messageDesc(file_tagn_v1_auth, 5);

/**
 * LoginRequest is the request message of Login.
 *
 * @generated from message tagn.v1.LoginRequest
 */
export type LoginRequest = Message<"tagn.v1.LoginRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;
};

/**
 * Describes the message tagn.v1.LoginRequest.
 * Use `create(LoginRequestSchema)` to create a new message.
 */
export const LoginRequestSchema: GenMessage<LoginRequest> = /*@__PURE__*/
  messageDesc(file_tagn_v1_auth, 6);

/**
 * LoginResponse is the response message of Login.
 *
 * @generated from message tagn.v1.LoginResponse
 */
export type LoginResponse = Message<"tagn.v1.LoginResponse"> & {
  /**
   * @generated from field: tagn.v1.User user = 1;
   */
  user?: User | undefined;

  /**
   * @generated from field: tagn.v1.TokenPair tokens = 2;
   */
  tokens?: TokenPair | undefined;
};

/**
 * Describes the message tagn.v1.LoginResponse.
 * Use `create(LoginResponseSchema)` to create a new message.
 */
export const LoginResponseSchema: GenMessage<LoginResponse> = /*@__PURE__*/
  messageDesc(file_tagn_v1_auth, 7);

/**
 * RefreshRequest is the request message of Refresh.
 *
 * @generated from message tagn.v1.RefreshRequest
 */
export type RefreshRequest = Message<"tagn.v1.RefreshRequest"> & {
  /**
   * @generated from field: string refresh_token = 1;
   */
  refreshToken: string;
};

/**
 * Describes the message tagn.v1.RefreshRequest.
 * Use `create(RefreshRequestSchema)` to create a new message.
 */
export const RefreshRequestSchema: GenMessage<RefreshRequest> = /*@__PURE__*/
  messageDesc(file_tagn_v1_auth, 8);

/**
 * RefreshResponse is the response message of Refresh.
 *
 * @generated from message tagn.v1.RefreshResponse
 */
export type RefreshResponse = Message<"tagn.v1.RefreshResponse"> & {
  /**
   * @generated from field: tagn.v1.TokenPair tokens = 1;
   */
  tokens?: TokenPair | undefined;
};

/**
 * Describes the message tagn.v1.RefreshResponse.
 * Use `create(RefreshResponseSchema)` to create a new message.
 */
export const RefreshResponseSchema: GenMessage<RefreshResponse> = /*@__PURE__*/
  messageDesc(file_tagn_v1_auth, 9);

/**
 * LogoutRequest is the request message of Logout.
 *
 * @generated from message tagn.v1.LogoutRequest
 */
export type LogoutRequest = Message<"tagn.v1.LogoutRequest"> & {
  /**
   * @generated from field: string refresh_token = 1;
   */
  refreshToken: string;
};

/**
 * Describes the message tagn.v1.LogoutRequest.
 * Use `create(LogoutRequestSchema)` to create a new message.
 */
export const LogoutRequestSchema: GenMessage<LogoutRequest> = /*@__PURE__*/
  messageDesc(file_tagn_v1_auth, 10);

/**
 * LogoutResponse is the response message of Logout.
 *
 * @generated from message tagn.v1.LogoutResponse
 */
export type LogoutResponse = Message<"tagn.v1.LogoutResponse"> & {
};

/**
 * Describes the message tagn.v1.LogoutResponse.
 * Use `create(LogoutResponseSchema)` to create a new message.
 */
export const LogoutResponseSchema: GenMessage<LogoutResponse> = /*@__PURE__*/
  messageDesc(file_tagn_v1_auth, 11);

/**
 * GetMeRequest is the request message of GetMe.
 *
 * @generated from message tagn.v1.GetMeRequest
 */
export type GetMeRequest = Message<"tagn.v1.GetMeRequest"> & {
};

/**
 * Describes the message tagn.v1.GetMeRequest.
 * Use `create(GetMeRequestSchema)` to create a new message.
 */
export const GetMeRequestSchema: GenMessage<GetMeRequest> = /*@__PURE__*/
  messageDesc(file_tagn_v1_auth, 12);

/**
 * GetMeResponse is the response message of GetMe.
 *
 * @generated from message tagn.v1.GetMeResponse
 */
export type GetMeResponse = Message<"tagn.v1.GetMeResponse"> & {
  /**
   * @generated from field: tagn.v1.User user = 1;
   */
  user?: User | undefined;
};

/**
 * Describes the message tagn.v1.GetMeResponse.
 * Use `create(GetMeResponseSchema)` to create a new message.
 */
export const GetMeResponseSchema: GenMessage<GetMeResponse> = /*@__PURE__*/
  messageDesc(file_tagn_v1_auth, 13);

/**
 * CreateInvitationRequest is the request message of CreateInvitation.
 *
 * @generated from message tagn.v1.CreateInvitationRequest
 */
export type CreateInvitationRequest = Message<"tagn.v1.CreateInvitationRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * Describes the message tagn.v1.CreateInvitationRequest.
 * Use `create(CreateInvitationRequestSchema)` to create a new message.
 */
export const CreateInvitationRequestSchema: GenMessage<CreateInvitationRequest> = /*@__PURE__*/
  messageDesc(file_tagn_v1_auth, 14);

/**
 * CreateInvitationResponse is the response message of CreateInvitation.
 *
 * @generated from message tagn.v1.CreateInvitationResponse
 */
export type CreateInvitationResponse = Message<"tagn.v1.CreateInvitationResponse"> & {
  /**
   * @generated from field: tagn.v1.Invitation invitation = 1;
   */
  invitation?: Invitation | undefined;

  /**
   * Registration link containing the invitation token.
   *
   * @generated from field: string link = 2;
   */
  link: string;
};

/**
 * Describes the message tagn.v1.CreateInvitationResponse.
 * Use `create(CreateInvitationResponseSchema)` to create a new message.
 */
export const CreateInvitationResponseSchema: GenMessage<CreateInvitationResponse> = /*@__PURE__*/
  messageDesc(file_tagn_v1_auth, 15);

/**
 * ListInvitationsRequest is the request message of ListInvitations.
 *
 * @generated from message tagn.v1.ListInvitationsRequest
 */
export type ListInvitationsRequest = Message<"tagn.v1.ListInvitationsRequest"> & {
};

/**
 * Describes the message tagn.v1.ListInvitationsRequest.
 * Use `create(ListInvitationsRequestSchema)` to create a new message.
 */
export const ListInvitationsRequestSchema: GenMessage<ListInvitationsRequest> = /*@__PURE__*/
  messageDesc(file_tagn_v1_auth, 16);

/**
 * ListInvitationsResponse is the response message of ListInvitations.
 *
 * @generated from message tagn.v1.ListInvitationsResponse
 */
export type ListInvitationsResponse = Message<"tagn.v1.ListInvitationsResponse"> & {
  /**
   * @generated from field: repeated tagn.v1.Invitation invitations = 1;
   */
  invitations: Invitation[];
};

/**
 * Describes the message tagn.v1.ListInvitationsResponse.
 * Use `create(ListInvitationsResponseSchema)` to create a new message.
 */
export const ListInvitationsResponseSchema: GenMessage<ListInvitationsResponse> = /*@__PURE__*/
  messageDesc(file_tagn_v1_auth, 17);

/**
 * AuthService handles invitation-only registration and token based sessions.
 *
 * @generated from service tagn.v1.AuthService
 */
export const AuthService: GenService<{
  /**
   * GetInvitation returns the details of a pending invitation (public).
   *
   * @generated from rpc tagn.v1.AuthService.GetInvitation
   */
  getInvitation: {
    methodKind: "unary";
    input: typeof GetInvitationRequestSchema;
    output: typeof GetInvitationResponseSchema;
  },
  /**
   * Register creates an account by redeeming an invitation token (public).
   *
   * @generated from rpc tagn.v1.AuthService.Register
   */
  register: {
    methodKind: "unary";
    input: typeof RegisterRequestSchema;
    output: typeof RegisterResponseSchema;
  },
  /**
   * Login exchanges credentials for a token pair (public).
   *
   * @generated from rpc tagn.v1.AuthService.Login
   */
  login: {
    methodKind: "unary";
    input: typeof LoginRequestSchema;
    output: typeof LoginResponseSchema;
  },
  /**
   * Refresh rotates a refresh token and issues a new token pair (public).
   *
   * @generated from rpc tagn.v1.AuthService.Refresh
   */
  refresh: {
    methodKind: "unary";
    input: typeof RefreshRequestSchema;
    output: typeof RefreshResponseSchema;
  },
  /**
   * Logout revokes the given refresh token.
   *
   * @generated from rpc tagn.v1.AuthService.Logout
   */
  logout: {
    methodKind: "unary";
    input: typeof LogoutRequestSchema;
    output: typeof LogoutResponseSchema;
  },
  /**
   * GetMe returns the authenticated user.
   *
   * @generated from rpc tagn.v1.AuthService.GetMe
   */
  getMe: {
    methodKind: "unary";
    input: typeof GetMeRequestSchema;
    output: typeof GetMeResponseSchema;
  },
  /**
   * CreateInvitation invites a new user by email.
   *
   * @generated from rpc tagn.v1.AuthService.CreateInvitation
   */
  createInvitation: {
    methodKind: "unary";
    input: typeof CreateInvitationRequestSchema;
    output: typeof CreateInvitationResponseSchema;
  },
  /**
   * ListInvitations lists invitations created by the authenticated user.
   *
   * @generated from rpc tagn.v1.AuthService.ListInvitations
   */
  listInvitations: {
    methodKind: "unary";
    input: typeof ListInvitationsRequestSchema;
    output: typeof ListInvitationsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_tagn_v1_auth, 0);

